import React from "react";
import { connect } from "react-redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";

import * as types from "../../constants/ComponentConstants";
import FinancieelPageHelper from "./FinancieelPageHelper";


class FinancieelPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.pageHelper = new FinancieelPageHelper(this);
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	render() {
		return (
			<Section title="Financieel" color={types.COLOR_PINK_LIGHT}>
				<Fieldset>
					Dit tabblad omvat het financiële luik van jouw aanvraag. Gebruik de knoppen aan de linkerkant om alle gegevens in te vullen.
					<br /> <br />
					De financiële duurzaamheid van jouw project wil zeggen dat de jaarlijkse inkomsten en uitgaven, over een periode van 10 jaar, minstens in evenwicht zijn.
					<br />
					De financiële haalbaarheid van jouw project betekent dat de financiering gegarandeerd is, rekening houdend met de eventuele toekenning van een (minimum) subsidie. De totale ingediende investeringskosten moeten dus minstens in evenwicht zijn met de aangetoonde financiering(en).
					<br /> <br />
					Let op: enkel volledig gefinancierde projecten mét een begroting in evenwicht kunnen ingediend worden!
					<br /><br />
				</Fieldset>
			</Section >
		);
	}
}

FinancieelPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;

	return {
		dossierId: dossierId
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(FinancieelPage));